import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { t } from 'i18next';
import { residentListSettingsSlice } from '../redux/config/residentListSettings';
import { selfDataSlice } from '../redux/config/selfData';
import { useAuth } from '../contexts/AuthContext';

export const Logout: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { signOut } = useAuth();

  React.useEffect(() => {
    const handleLogout = async () => {
      dispatch(residentListSettingsSlice.actions.resetFilterCondition());
      dispatch(selfDataSlice.actions.reset());
      localStorage.setItem('unit', 'null');
      localStorage.setItem('condition', 'all');

      await signOut().then(() => {
        history.push('/login');
      });
    };

    handleLogout();
  }, [dispatch, history]);

  return <p>{t('logout', 'ログアウト')}</p>;
};
